<template>
  <div class="uk-container">
    <user-manage :type="1" :uid="$route.params.id" />
  </div>
</template>

<script>
import UserManage from '@/components/user/Manage.vue'

export default {
  name: 'ViewAdminManage',

  components: { UserManage }
}
</script>
